import React, { useRef, useState, useEffect } from "react";
import { Box, Typography, Chip, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

export const PageHeaderTabs = ({ title, tabs = [], activeTab, onTabChange }) => {
  const scrollRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);

  // Check if scrolling is possible
  const checkScrollButtons = () => {
    const el = scrollRef.current;
    if (el) {
      setShowLeft(el.scrollLeft > 0);
      setShowRight(el.scrollWidth > el.clientWidth + el.scrollLeft);
    }
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    checkScrollButtons();
    el.addEventListener("scroll", checkScrollButtons);
    window.addEventListener("resize", checkScrollButtons);
    return () => {
      el.removeEventListener("scroll", checkScrollButtons);
      window.removeEventListener("resize", checkScrollButtons);
    };
  }, []);

  const scroll = (direction) => {
    const el = scrollRef.current;
    if (el) {
      const scrollAmount = direction === "left" ? -150 : 150;
      el.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", marginX: "22px", marginTop: "22px", marginBottom: "11px" }}>
      {/* Title */}
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          mr: 2,
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </Typography>

      {/* Left Scroll Button */}
      {showLeft && (
        <IconButton size="small" onClick={() => scroll("left")}>
          <ChevronLeft />
        </IconButton>
      )}

      {/* Scrollable Chip Container */}
      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          alignItems: "center",
          overflowX: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::-webkit-scrollbar": { display: "none" },
          gap: 1,
          flex: 1,
        }}
      >
        {tabs.map((tab) => (
          <Chip
            key={tab}
            label={tab}
            clickable
            onClick={() => onTabChange?.(tab)}
            sx={{
              fontWeight: 500,
              fontSize: "0.9rem",
              textTransform: "capitalize",
              px: 2,
              borderRadius: "20px",
              backgroundColor: activeTab === tab ? "#674BF5" : "#fff",
              color: activeTab === tab && "#fff",
              boxShadow: activeTab === tab ? "0 2px 8px rgba(0,0,0,0.1)" : "none",
              "&:hover": {
                backgroundColor: activeTab === tab ? "#674BF5" : "#fff",
              },
            }}
          />
        ))}
      </Box>

      {/* Right Scroll Button */}
      {showRight && (
        <IconButton size="small" onClick={() => scroll("right")}>
          <ChevronRight />
        </IconButton>
      )}
    </Box>
  );
};
